import { render, staticRenderFns } from "./PaymentInputV2.vue?vue&type=template&id=c2265a5e&scoped=true&"
import script from "./PaymentInputV2.vue?vue&type=script&lang=js&"
export * from "./PaymentInputV2.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInputV2.vue?vue&type=style&index=0&id=c2265a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2265a5e",
  null
  
)

export default component.exports